import { render, staticRenderFns } from "./SettingsWrapper.vue?vue&type=template&id=47e8c712"
import script from "./SettingsWrapper.vue?vue&type=script&lang=ts"
export * from "./SettingsWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports